import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, TextField } from "@material-ui/core";
import "../styles/AdminApplications.css";
import Pagination from "@material-ui/lab/Pagination";
import { upperFirst } from "lodash";
import { ApiURL } from "../constants/ApiUrl";
import * as XLSX from "xlsx";

// import AdminApplicationsView from './AdminApplicationsView'
import axiosInstance from "../services/AxiosInstance.js";
// import React, {useState, useEffect} from 'react'
// import { useDispatch } from 'react-redux'
// import {Link} from "react-router-dom"
import "../styles/ApplicationHome.css";

function formatMemberOnForExport(value) {
  if (value == null || value === "") return "";
  const d = new Date(value);
  if (!Number.isNaN(d.getTime())) return d.toLocaleDateString();
  return String(value);
}

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

function AdminApplications() {
  const [Type, setType] = useState("");
  // console.log(Type,'ttttttttt.................')
  const [AppList, setAppList] = useState([]);
  const [Page, setPage] = useState(0);
  const [TotalPages, setTotalPages] = useState(0);
  const [TotalItems, setTotalItems] = useState(0);
  const [searchdata, setSearchdata] = useState("");
  const [Search, setSearch] = useState("");
  const [TotalResult, setTotalResult] = useState(0);

  var search = 12;
  const onSearchChange = (e) => {
    // search = e.target.value

    // console.log(e.target.value,'vhvvvvvv')
    // if (e.target.value === '')
    //     getData(0, 10);
    setSearch(e.target.value);
    console.log(Search, "searching");
    // searchData(Page,10)
  };

  const onKeyDown = (e) => {
    console.log(e.key);
    if (e.key === "Enter") {
      searchData(Page, 50);
    }
  };

  async function getData(page, limit) {
    // const result = await axios.post(`${ApiURL}/api/get_applications?page=${page}&limit=${limit}&Type=${Type}`);
    const result = await axiosInstance.post(
      `${ApiURL}/api/get_applications?page=${page}&limit=${limit}&Type=${Type}`
    );
    console.log(AppList, "listttttt");

    setAppList(result.data.data);

    setTotalPages(result.data.totalPages);
    setTotalItems(result.data.totalItems);
  }
  useEffect(() => {
    getData(0, 50);
  }, []);

  useEffect(() => {
    getData(Page, 50);
  }, [Page, Type]);

  async function searchData(page, limit) {
    console.log("Page & Type", page, Type);
    if (!Search) setSearch("");

    if (!Type) setType("");
    // const result = await axios.post(`${ApiURL}/api/get_applications?page=${page}&limit=${limit}&Type=${Type}&search=${Search}`);//added Type for search
    const result = await axiosInstance.post(
      `${ApiURL}/api/get_applications?page=${page}&limit=${limit}&Type=${Type}&search=${Search}`
    ); //added Type for search
    console.log(result.data, "search new members");
    setAppList(result.data.data);
    setTotalPages(result.data.totalPages);
    setTotalResult(result.data.totalItems);
  }

  // start of export excel file

  const handleDownload = async () => {
    const result = await axios.get(`${ApiURL}/api/get_all_new_members`);
    exportToCSV(result.data.data, "Search");
  };
  const downloadData = () => {
    const detailsList = [];
    console.log("Downloading", Search, Type);
    axios
      .get(`${ApiURL}/api/downloadSelectedData?search=${Search}&type=${Type}`)
      .then((res) => {
        res.data.data.forEach((element) => {
          console.log(element.pincode, "pinnnnnnnnn");
          const memberOn =
            new Date(element.expiry_date).getDate() +
            "/" +
            (new Date(element.expiry_date).getMonth() + 1) +
            "/" +
            new Date(element.expiry_date).getFullYear();
          const date =
            new Date(element.dob).getDate() +
            "/" +
            (new Date(element.dob).getMonth() + 1) +
            "/" +
            new Date(element.dob).getFullYear();
          var data = {
            "Membership Number": element.mem_no,
            Name: element.name,
            "Blood Group": element.blood_group,
            "Medical College": element.college,
            "Date of Birth": date,
            Email: element.email,
            Gender: element.gender,
            "Member On": formatMemberOnForExport(element.memberOn),
            "Student Membership Valid Till": memberOn,
            Address: element.address,
            Pincode: element.pincode,
            "Nmo state": element.nmo_state,
            Phone: element.phone,
            Prant: element.prant,
            Qualifications: element.qualifications,
            "Ref. Membership Number": element.ref_membership_no,
            "Ref. Person": element.ref_person,
            "Ref. Person Phone": element.ref_person_phone,
            "Registration Number": element.regno,
            Specialization: element.specialization,
            "State sec Email": element.state_sec_email,
            "Application Fee": element.appFee,
          };
          detailsList.push(data);
        });

        // console.log(detailsList, "listtttt")

        exportToCSV(detailsList, "Search");
      })
      .catch((err) => {
        console.log(err, "fdh");
      });
  };

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    const element = document.createElement("a");
    element.href = URL.createObjectURL(data);
    const dd = new Date();
    element.download = `new-applicants-data-backup-${dd.getDate()}-${
      dd.getMonth() + 1
    }-${dd.getFullYear()}.xlsx`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
    // FileSaver.saveAs(data, fileName + fileExtension);
  };

  // end of export excel file

  const handleSearch = (e) => {
    // getData(Page, 50);
    // setSearch(e.target.value);
    searchData(Page, 50);

    console.log("Handle Search", Search);
  };

  const handlePageChange = (e, value) => {
    setPage(value - 1);
  };
  const handleView = (value) => {
    window.open(`/admin/applications/${value}`, "_blank", "noopener,noreferrer");
  };
  return (
    <>
      <div className="admNewApp">
        <h1>New Application List</h1>
        <div style={{ display: "flex" }}>
          <div className="quesCon">
            <h4>Select Application Type</h4>
            <select
              className="NewSelects"
              onChange={(e) => setType(e.target.value)}
            >
              {/* <option value='none'>Select Application Type</option> */}
              <option value="all">All Members</option>
              <option value="single">Single Doctors</option>
              <option value="couple">Couple Doctors</option>
              <option value="student">Students</option>
            </select>
          </div>

          <div
            style={{
              minWidth: "50%",
              gap: "20px",
              marginTop: "55px",
              marginLeft: "30px",
            }}
            className="searchContainer"
          >
            <TextField
              style={{ width: "50%" }}
              placeholder="Search"
              label="Search Name"
              onChange={onSearchChange}
              onKeyDown={onKeyDown}
            />
            <Button
              variant="contained"
              style={{ height: "40px" }}
              onClick={handleSearch}
            >
              Search
            </Button>
            {/* <Button
              variant="contained"
              color="secondary"
              style={{ height: "40px" }}
              onClick={downloadData}
            >
              <i class="fa fa-download"></i>
            </Button> */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                variant="contained"
                // sx={{ height: 2 }}
                color="primary"
                onClick={handleDownload}
              >
                New Applicants Data Download
              </Button>
            </div>
          </div>
        </div>
        <Pagination
          count={TotalPages}
          page={Page + 1}
          onChange={handlePageChange}
          variant="outlined"
          shape="rounded"
        />
        <p>
          <b>{TotalItems} pending applications.</b>
        </p>
        <table className="appTable">
          <tr>
            <th>S.No</th>
            <th>Doctor Name</th>
            {/* <th>Application ID</th> */}
            <th>Application Type</th>
            <th>Application Date</th>
            <th>Mode of Payment</th>
            <th>Action</th>
          </tr>
          {AppList.map((item, index) => (
            <tr key={item.memberID}>
              <td>{Page * 50 + (index + 1)}</td>
              <td>{item.name}</td>
              {/* <td>{item.appId}</td> */}
              <td>{upperFirst(item.appType)}</td>
              <td>{new Date(item.createdAt).toDateString()}</td>
              <td>{item.payment.mode.toUpperCase()}</td>
              {/* <td>{item.appApproved ? "Approved" : "Not Approved"}</td> */}
              <td>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleView(item._id)}
                >
                  View
                </Button>
              </td>
            </tr>
          ))}
        </table>
      </div>
    </>
  );
}

export default AdminApplications;
